import { render, staticRenderFns } from "./AddWorkPage.vue?vue&type=template&id=3b201332&"
import script from "./AddWorkPage.vue?vue&type=script&lang=js&"
export * from "./AddWorkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports